/* eslint-disable no-unused-vars */
import model from '@/models/User'
import JwtService from '@/common/jwt.service'
import {
    GET_LIST,
    GET_SINGLE,
    CREATE,
    UPDATE,
    DELETE
} from '../actions.type'
import {
    SET_LIST,
    SET_SINGLE,
    SET_ERROR
} from '../mutations.type'

export const MODULE_NAME = 'USERS'
export const LIST_ID = 'USERS_LIST'

const initialState = {
    errors: {},
    single: null,
    list: []
}

export const state = Object.assign({}, initialState)

const actions = {
    [GET_SINGLE]: ({
        commit
    }, {
        id = null
    }) =>
        new Promise((resolve, reject) => {
            if (id === null) {
                reject(
                    new Error(
                        'Required property id is not set in: users pages, action GET_SINGLE'
                    )
                )
            } else {
                model
                    .getSingle(id)
                    .then((result) => {
                        commit(SET_SINGLE, result)
                        resolve(
                            result
                        )
                    })
                    .catch(error => {
                        reject(error)
                    })
            }
        }),
    [CREATE]: ({
        commit
    }, item) =>
        new Promise((resolve, reject) => {
            model
                .create(item)
                .then((
                    data
                ) => {
                    resolve(
                        data
                    )
                })
                .catch(({
                    response
                }) => {
                    commit(SET_ERROR, 'CREATE', response.data.errors)
                    reject(response)
                })
        }),
    [GET_LIST]: ({
        commit
    }, {
        query = {}
    }) => new Promise((resolve, reject) => {
        return model
            .getList(query)
            .then(({
                data,
                headers
            }) => {
                commit(SET_LIST, {
                    result: {
                        total: parseInt(headers['x-total-count']),
                        data
                    }
                })
                resolve({
                    data,
                    headers
                })
            }).catch(error => {
                if (error.response && error.response.status && error.response.status === 404) {
                    resolve({
                        data: [],
                        headers: {
                            'x-total-count': 0
                        }
                    })
                } else {
                    reject(error)
                }
            })

    }),
    [UPDATE]: ({
        commit
    }, item) =>
        new Promise((resolve, reject) => {
            if (item === null) {
                reject(
                    new Error(
                        'Required property item is not set in: module user, action UPDATE'
                    )
                )
            } else {
                model
                    .update(item)
                    .then((
                        data
                    ) => {
                        resolve(
                            data
                        )
                    })
                    .catch(({
                        response
                    }) => {
                        commit(SET_ERROR, 'UPDATE', response.data.errors)
                    })
            }
        }),
    [DELETE]: ({
        commit
    }, id = null) =>
        new Promise((resolve, reject) => {
            if (id === null) {
                reject(
                    new Error(
                        'Required property item is not set in: users module, action DELETE'
                    )
                )
            } else {
                model
                    .delete(id)
                    .then((
                        data
                    ) => {
                        resolve(
                            data
                        )
                    })
                    .catch(({
                        response
                    }) => {
                        commit(SET_ERROR, 'DELETE', response.data.errors)
                    })
            }
        }),
}

const mutations = {
    [SET_ERROR] (state, type, error) {
        state.errors[type] = error
    },
    [SET_LIST] (state, {
        result
    }) {
        state.list = result
    },
    [SET_SINGLE] (state, result) {
        // Sostituisco nella lista utenti dello store l'utente singolo
        if (state.list.data) {
            state.list.data = state.list.data.map((u) => {
                if (u.id === result.id) {
                    u = result.data
                }
                return u
            })
        }
        state.single = result.data
    }
}

const getters = {
    getList: state => {
        if (state.list) {
            return state.list
        }
        return null
    },
    getSingle: state => {
        if (state.single) {
            return state.single
        }
        return null
    }
}

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
}
